export const getMenuData = [
	{},
	{
		title: 'Dashboard',
		key: 'dashboard',
		icon: 'fe fe-bookmark',
		url: '/dashboard',
	},
	{
		title: 'Profile',
		key: 'profile',
		icon: 'fe fe-user',
		url: '/profile',
	},
	{
		title: 'Groups Categories',
		key: 'group_categories',
		icon: 'fe fe-grid',
		url: '/setting',
	},
	{
		title: 'Accounts',
		key: 'account',
		icon: 'fe fe-users',
		url: '/account',
	},
	{
		title: 'Evolution',
		key: 'evolution',
		icon: 'fe fe-maximize',
		url: '/evolution',
	},
	{
		title: 'Trending',
		key: 'activity',
		icon: 'fe fe-activity',
		url: '/trending',
	},
	{
		title: 'Reports',
		key: 'reports',
		icon: 'fe fe-file-text',
		url: '/reports',
	},
	/* {
		title: 'Settings',
		key: 'settings',
		icon: 'fe fe-settings',
		url: '/setting',
	}, */
]
